import React, { useState } from 'react';

interface LoginPageProps {
  onLogin: () => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (email === 'AL07182039@tecmilenio.mx' && password === '010614010614Pvl') {
      onLogin();
    } else {
      setError('Usuario o contraseña incorrectos');
    }
  };

  const inlineStyles = `
    * {
      margin: 0px;
      padding: 0px;
    }
    
    .login-container {
      height: 100vh;
      width: 100vw;
      background-color: #ffffff;
      font-family: "Segoe UI", "Segoe", "SegoeUI-Regular-final", Tahoma, Helvetica, Arial, sans-serif;
      font-size: 0.9em;
      display: flex;
    }
    
    .branding-wrapper {
      width: calc(100% - 500px);
      height: 100%;
      background-color: #4488dd;
      background-image: url('/loginpicture.png');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    
    .content-wrapper {
      position: relative;
      width: 500px;
      height: 100vh;
      overflow: hidden;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
    }
    
    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 20px 50px 20px 50px;
      justify-content: center;
    }
    
    .header {
      font-size: 1.8em;
      font-weight: lighter;
      font-family: "Segoe UI Light", "Segoe", "SegoeUI-Light-final", Tahoma, Helvetica, Arial, sans-serif;
      margin-bottom: 30px;
      width: 350px;
      word-wrap: break-word;
    }
    
    .header img {
      width: auto;
      height: auto;
      max-width: 100%;
    }
    
    .work-area {
      word-wrap: break-word;
      width: 350px;
      flex: 1;
    }
    
    .full-width {
      width: 342px;
    }
    
    .field-margin {
      margin-bottom: 6px;
    }
    
    .group-margin {
      margin-bottom: 15px;
    }
    
    .submit-margin {
      margin-top: 20px;
      margin-bottom: 15px;
      text-align: right;
    }
    
    input.text {
      height: 28px;
      padding: 0px 3px 0px 3px;
      border: solid 1px #BABABA;
      font-size: 1.0em;
      max-width: 100%;
      font-family: inherit;
      margin-bottom: 8px;
    }
    
    input.text:focus {
      border: 1px solid #6B6B6B;
    }
    
    input[type="submit"] {
      border: none;
      background-color: rgb(38, 114, 236);
      min-width: 80px;
      width: auto;
      height: 30px;
      padding: 4px 20px 6px 20px;
      border-style: solid;
      border-width: 1px;
      transition: background 0s;
      color: rgb(255, 255, 255);
      cursor: pointer;
      margin-bottom: 8px;
    }
    
    input[type="submit"]:hover {
      background: rgb(212, 227, 251);
    }
    
    a {
      color: #2672ec;
      text-decoration: none;
      background-color: transparent;
    }
    
    .error {
      color: #a94442;
      background-color: #f2dede;
      border-color: #ebccd1;
    }
    
    .ethos-mi-tec {
      width: 195px;
      height: 65px;
      border-color: #41719C;
      border-radius: 11px;
      border-style: solid;
      border-width: 3px;
      padding-left: 15px;
      padding-right: 3px;
      padding-top: 12px;
      padding-bottom: 8px;
      font-family: Gotham, "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 12px;
      font-style: normal;
      display: inline-block;
      margin-top: 8px;
      box-sizing: border-box;
    }
    
    .footer {
      height: 30px;
      padding: 8px 50px 0px 50px;
      color: #666666;
      font-size: 0.78em;
      text-align: center;
    }
    
    @media only screen and (max-width: 600px) {
      .branding-wrapper {
        display: none;
      }
      
      .content-wrapper {
        float: none;
        width: 100%;
        margin: 0px auto;
      }
      
      .content, .footer, .header {
        width: 400px;
        padding-left: 0px;
        padding-right: 0px;
        margin-left: auto;
        margin-right: auto;
      }
      
      .work-area {
        width: 100%;
      }
      
      .full-width {
        width: 392px;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: inlineStyles }} />
      <div className="login-container">
        {/* Left side - Branding */}
        <div className="branding-wrapper" />

        {/* Right side - Content */}
        <div className="content-wrapper">
          <div className="content">
            {/* Header with logos */}
            <div className="header">
              <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img 
                    src="/logo.png" 
                    alt="TecMilenio Logo" 
                    style={{ 
                      height: '28px', 
                      width: 'auto',
                      filter: 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(120deg) brightness(104%) contrast(97%)',
                      marginRight: '6px'
                    }}
                  />
                  <span style={{ color: '#0d9488', fontWeight: 'bold', fontSize: '16px' }}>TECMILENIO</span>
                </div>
              </div>
            </div>

            {/* Work Area */}
            <div className="work-area">
              <div style={{ marginBottom: '12px', fontSize: '14px', fontWeight: 'normal' }}>
                Para iniciar la sesión ingresa tu usuario y contraseña
              </div>

              <form onSubmit={handleSubmit}>
                <div className="field-margin">
                  <input
                    type="email"
                    placeholder="Usuario"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="text full-width"
                    required
                  />
                </div>

                <div className="field-margin">
                  <input
                    type="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="text full-width"
                    required
                  />
                </div>

                <div style={{ textAlign: 'right', marginBottom: '8px' }}>
                  <button type="button" style={{ background: 'none', border: 'none', color: '#2672ec', cursor: 'pointer', fontSize: '0.9em' }}>
                    ¿Olvidaste tu contraseña?
                  </button>
                </div>

                {error && (
                  <div className="error" style={{ padding: '8px', marginBottom: '8px', borderRadius: '4px' }}>
                    {error}
                  </div>
                )}

                <div className="submit-margin">
                  <input type="submit" value="Iniciar sesión" />
                </div>
              </form>

              {/* Help Section */}
              <div className="group-margin">
                <div style={{ marginBottom: '8px', fontWeight: 'normal' }}>¿Necesitas ayuda? Contáctanos</div>
                <ul style={{ listStyleType: 'disc', color: 'blue', paddingLeft: '16px' }}>
                  <li><button type="button" style={{ background: 'none', border: 'none', color: '#2672ec', cursor: 'pointer' }}>Alumnos y egresados Tec de Monterrey</button></li>
                  <li><button type="button" style={{ background: 'none', border: 'none', color: '#2672ec', cursor: 'pointer' }}>Alumnos Tecmilenio</button></li>
                  <li><button type="button" style={{ background: 'none', border: 'none', color: '#2672ec', cursor: 'pointer' }}>Colaboradores</button></li>
                </ul>
              </div>

              {/* ETHOS Box */}
              <div className="ethos-mi-tec">
                <div style={{ color: 'black', fontWeight: 'bold', fontSize: '14px', marginBottom: '2px' }}>
                  Reporta en <span style={{ color: '#41719C' }}>ETHOS</span>
                </div>
                <div style={{ color: 'black', fontSize: '12px' }}>
                  las faltas al código de ética
                </div>
              </div>

              {/* Privacy Notice */}
              <div style={{ marginTop: '10px', textAlign: 'center' }}>
                <button 
                  type="button"
                  style={{
                    backgroundColor: '#5DADE2',
                    color: 'white',
                    padding: '6px 12px',
                    fontSize: '11px',
                    border: 'none',
                    cursor: 'pointer',
                    borderRadius: '4px'
                  }}
                >
                  Avisos de Privacidad
                </button>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="footer">
            <div style={{ color: '#696969', textAlign: 'center' }}>© 2026</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;